<template>
  <div class="homepage-setting">
    <el-tabs v-model="setupName" type="card" @tab-click="handleSetup">
      <el-tab-pane label="首页跳转" name="setup0"/>
      <el-tab-pane label="择校页跳转" name="setup1"/>
    </el-tabs>
    <template>
      <el-form
        :rules="rules"
        ref="dataForm"
        :model="temp"
        label-position="left"
        label-width="140px"
        class="link-form">
        <el-form-item label="跳转" prop="redirect_tp">
            <el-radio-group v-model="temp.redirect_tp">       
              <el-radio :label="1">链接</el-radio>
              <el-radio :label="12">小程序</el-radio>
              <el-radio :label="23">容器化</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="APPID" prop="appid" v-if="temp.redirect_tp>1">
            <el-input type="text" v-model="temp.appid"/>
          </el-form-item>
          <el-form-item label="跳转链接" prop="path_args" v-if="temp.redirect_tp!=12">
            <el-input type="text" v-model="temp.path_args"/>
          </el-form-item>
      </el-form>
      <div style="margin-top: 10px">
        <el-button type="primary" @click="saveLink">保存</el-button>
      </div>
    </template>
  </div>
</template>

<script>
import { getStudyAbroadUrl, saveStudyAbroadUrl } from '@/api/study-abroad'

export default {
  name: 'PolicyManagement',

  data() {
    return {
      setupName: 'setup0',
      temp: {
        position: 1,
        redirect_tp: 1,
        appid: '',
        path_args: '',
      },
      tabs: 0,
      rules: {
        appid: [
          { required: true, message: '请输入APPID', trigger: 'blur' },
        ],
        path_args: [
          { required: true, message: '请输入跳转链接', trigger: 'blur' },
        ],
      },
    }
  },
  components: {},
  watch: {},
  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      getStudyAbroadUrl(this.tabs==0?1:2).then((res) => {
        let redirect_args = null;
        this.temp.redirect_tp = res.data.redirect_tp?res.data.redirect_tp:1
        if(res.data.redirect_args){
          if(res.data.redirect_args.includes('appid')) {
            redirect_args = JSON.parse(res.data.redirect_args) 
            this.temp.appid = redirect_args.appid
            this.temp.path_args = redirect_args.path_args
          } else {
            // 如果不包含appid，直接赋值给path_args
            if(res.data.redirect_tp==12){
              this.temp.appid = res.data.redirect_args
            }else{
              this.temp.path_args = res.data.redirect_args
            }
          }
        }
      })
    },
    // 切换参数设置
    handleSetup(tab, event) {
      this.tabs = tab.index
      this.temp = {
        position: tab.index==1?2:1,
        redirect_tp: 1,
        appid: '',
        path_args: '',
      },
      this.fetchData()
    },
    saveLink() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let data = {}
          if(this.temp.redirect_tp!=23){
            data = {
              redirect_tp:this.temp.redirect_tp,
              redirect_args:this.temp.redirect_tp==1?this.temp.path_args:this.temp.appid,
            }
          }else{
            data = {
              redirect_tp:this.temp.redirect_tp,
              redirect_args:JSON.stringify({appid:this.temp.appid,path_args:this.temp.path_args}),
            }
          }
          
          saveStudyAbroadUrl(this.temp.position,data).then(
            (res) => {
              if (res.code === 20000) {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                })
              }
            }
          )
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.homepage-setting {
  padding: 20px;
  .el-input {
    width: 300px;
  }
}
</style>
